var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.469c0-1.783 1.923-2.867 3.4-1.917l10.23 6.58c1.387.891 1.38 2.959-.012 3.841L9.387 20.456C7.91 21.392 6 20.306 6 18.531V5.47z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjxwYXRoIGQ9Ik02IDUuNDY5YzAtMS43ODMgMS45MjMtMi44NjcgMy40LTEuOTE3bDEwLjIzIDYuNThjMS4zODcuODkxIDEuMzggMi45NTktLjAxMiAzLjg0MUw5LjM4NyAyMC40NTZDNy45MSAyMS4zOTIgNiAyMC4zMDYgNiAxOC41MzFWNS40N3oiLz48L3N2Zz4=";
export { SvgPlay24 as ReactComponent };